import React from 'react';

export const otherCandidatesButtonLabel = (candidateCount: number): string =>
  `他の候補を見る（他${candidateCount}件）`;

const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: '13px',
  lineHeight: 1.2,
  whiteSpace: 'normal'
};

export const OtherCandidatesButtonLabel: React.FC<{ candidateCount: number }> = ({ candidateCount }) => (
  <span style={labelStyle}>
    他の候補を見る
    <br />
    {`（他${candidateCount}件）`}
  </span>
);

export const ChangeCancelButtonLabel: React.FC = () => (
  <span style={labelStyle}>
    変更を
    <br />
    キャンセル
  </span>
);
